import InfoBar from '../../ui/info-bar/info-bar'

const ContentLayout = ({ children }) => {
  return (
    <>
      <InfoBar />

      {children}
    </>
  )
}

export default ContentLayout
